angular.module('mobilezuz').service('Loyalty', [
    'Config', 'Api',
    function(Config, Api) {
        var self = this;

        self.getLoyaltyDriver = getLoyaltyDriver;
        self.getSpecialsLoyalty = getSpecialsLoyalty;

        function getLoyaltyDriver(loyaltyClubDriverId) {
            return Config.retailer.loyaltyClubDrivers.find(function(item) {
                return item.loyaltyClubDriverId === loyaltyClubDriverId
            })
        }

        function getSpecialsLoyalty(loyaltyClubIds, size) {
            return Api.request({
                method: 'GET',
                url: '/v2/retailers/:rid/branches/:bid/specials',
                params: {
                    size: size,
                    filters: {
                        "must": {
                            "term": {
                                "displayOnWeb":true,
                                "loyaltyClubsIds": loyaltyClubIds
                            },
                            "exists": ["loyaltyClubsIds"]
                        }
                    }
                }
            });
        }
    }]);




